import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "form-field-floating full my-5" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "form-field-floating reactive active my-4" }
const _hoisted_4 = {
  key: 0,
  class: "text-red"
}
const _hoisted_5 = { class: "form-field-floating reactive active my-4" }
const _hoisted_6 = {
  key: 1,
  class: "text-red"
}
const _hoisted_7 = { class: "form-field-floating reactive active my-4" }
const _hoisted_8 = {
  key: 2,
  class: "text-red"
}
const _hoisted_9 = { class: "form-field-floating reactive active my-4" }
const _hoisted_10 = {
  key: 3,
  class: "text-red"
}
const _hoisted_11 = { class: "form-field-floating reactive active my-4" }
const _hoisted_12 = { class: "form-field-floating full my-5" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "my-4" }

import { reactive, watch, ref } from 'vue';
    import { QuillEditor } from '@vueup/vue-quill'
    import { AMOUNT_FORMAT_CONFIG, INTEGER_FORMAT_CONFIG } from '@/utils';
    // @ts-expect-error raison: lib externe mal typée
    import Vue3TagsInput from 'vue3-tags-input';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketProduitFormGeneralView',
  props: {
        modelValue: { type: Object, default: null },
        startupFormDatas: { type: Object, required: true },
        id: { type: Number, default: null },
    },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

    // @ts-expect-error raison: lib externe mal typée
    const props = __props;
    const emit = __emit;

    const formData = ref({
        categorie_ids: [] as any[],
        sku: "",
        ean: "",
        nom: "",
        description: "",
        montant: 0,
        metadata: [] as any[],
        fournisseurs_ids: [] as any[],
        quantite: 0,
    });
    const errors = reactive({
        categorie_ids: "",
        sku: "",
        ean: "",
        nom: "",
        montant: "",
    });

    watch(
        () => props.modelValue,
        (newVal) => {
            if (newVal) { Object.assign(formData.value, newVal); }
        }, { immediate: true, deep: true }
    );

    watch(
        formData,
        (newVal) => { emit('update:modelValue', { ...newVal }) },
        { deep: true }
    );
    function handleChangeTag(newTags: any) {
        formData.value.metadata = newTags;
    }

return (_ctx: any,_cache: any) => {
  const _component_money3 = _resolveComponent("money3")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("select", {
        class: "form-input-select",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.categorie_ids) = $event)),
        name: "categorie_ids",
        id: "categorie_ids",
        multiple: "true",
        size: "1"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.startupFormDatas.categories, (categorie, index) => {
          return (_openBlock(), _createElementBlock("option", {
            value: categorie.id,
            key: 'categorie_' + index
          }, _toDisplayString(categorie.nom), 9, _hoisted_2))
        }), 128))
      ], 512), [
        [_vModelSelect, formData.value.categorie_ids]
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("label", { for: "categorie_ids" }, [
        _createTextVNode("Catégories "),
        _createElementVNode("b", { class: "color-danger" }, "*")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-input",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.sku) = $event)),
        name: "sku",
        id: "sku",
        placeholder: "",
        autocomplete: "off"
      }, null, 512), [
        [_vModelText, formData.value.sku]
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("label", { for: "sku" }, [
        _createTextVNode("SKU "),
        _createElementVNode("b", { class: "color-danger" }, "*")
      ], -1))
    ]),
    (!!errors['sku'])
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(errors['sku']), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-input",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.ean) = $event)),
        name: "ean",
        id: "ean",
        placeholder: "",
        autocomplete: "off"
      }, null, 512), [
        [_vModelText, formData.value.ean]
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("label", { for: "ean" }, "EAN (codes barres)", -1))
    ]),
    (!!errors['ean'])
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(errors['ean']), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-input",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.nom) = $event)),
        name: "nom",
        id: "nom",
        placeholder: "",
        autocomplete: "off"
      }, null, 512), [
        [_vModelText, formData.value.nom]
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("label", { for: "nom" }, [
        _createTextVNode("Désignation "),
        _createElementVNode("b", { class: "color-danger" }, "*")
      ], -1))
    ]),
    (!!errors['nom'])
      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(errors['nom']), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_money3, _mergeProps({
        class: "form-input",
        modelValue: formData.value.montant,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.montant) = $event)),
        name: "montant",
        id: "montant",
        placeholder: ""
      }, _unref(AMOUNT_FORMAT_CONFIG)), null, 16, ["modelValue"]),
      _cache[12] || (_cache[12] = _createElementVNode("label", { for: "montant" }, [
        _createTextVNode("Prix unitaire "),
        _createElementVNode("b", { class: "color-danger" }, "*")
      ], -1))
    ]),
    (!!errors['montant'])
      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(errors['montant']), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_money3, _mergeProps({
        class: "form-input",
        modelValue: formData.value.quantite,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.quantite) = $event)),
        name: "quantite",
        id: "quantite",
        placeholder: ""
      }, _unref(INTEGER_FORMAT_CONFIG), {
        readonly: props.id != null
      }), null, 16, ["modelValue", "readonly"]),
      _cache[13] || (_cache[13] = _createElementVNode("label", { for: "quantite" }, "Stock initial", -1))
    ]),
    _createElementVNode("div", _hoisted_12, [
      _withDirectives(_createElementVNode("select", {
        class: "form-input-select",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.fournisseurs_ids) = $event)),
        name: "fournisseurs_ids",
        id: "fournisseurs_ids",
        multiple: "true",
        size: "1"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.startupFormDatas.fournisseurs, (fournisseur, index) => {
          return (_openBlock(), _createElementBlock("option", {
            value: fournisseur.id,
            key: 'fournisseur_' + index
          }, _toDisplayString(fournisseur.nom_fournisseur), 9, _hoisted_13))
        }), 128))
      ], 512), [
        [_vModelSelect, formData.value.fournisseurs_ids]
      ]),
      _cache[14] || (_cache[14] = _createElementVNode("label", { for: "fournisseurs_ids" }, "Fournisseurs", -1))
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_14, [
        _cache[15] || (_cache[15] = _createElementVNode("label", { for: "nom" }, "Mots clés", -1)),
        _createVNode(_unref(Vue3TagsInput), {
          placeholder: "Saisir les mots clés",
          onOnTagsChanged: handleChangeTag,
          tags: formData.value.metadata
        }, null, 8, ["tags"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_unref(QuillEditor), {
        id: "description",
        placeholder: "Description",
        content: formData.value.description,
        "onUpdate:content": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.description) = $event)),
        contentType: "html",
        theme: "snow",
        style: {"height":"300px"}
      }, null, 8, ["content"])
    ])
  ]))
}
}

})